var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0078 15.6252C14.0078 15.9025 13.9065 16.1372 13.7038 16.3292C13.5118 16.5212 13.2771 16.6172 12.9998 16.6172H0.999812C0.733146 16.6172 0.498479 16.5159 0.295812 16.3132C0.103813 16.1212 0.0078125 15.8919 0.0078125 15.6252V2.61719H2.50381V0.617188H3.49581V2.61719H10.5038V0.617188H11.4958V2.61719H14.0078V15.6252ZM0.999812 5.60919H12.9998V3.60919H0.999812V5.60919ZM0.999812 15.6252H12.9998V6.61719H0.999812V15.6252ZM10.9998 14.6172V13.6092H12.0078V14.6172H10.9998Z",
    fill: "#474747"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.3feb0436510c9413aa46d88adcb61ce7.svg";
export { ForwardRef as ReactComponent };